export const MULTIBRAND_QUIZ_STEPS = {
  NO_BONUS_QUIZ: 1,
  GAME: 2,
  FINISH: 3,
};
